export const palette = {
  'palette-red': '#E51B00',
  'palette-red-dark-100': '#CC1800',
  'palette-red-dark-200': '#BA1309',
  'palette-red-dark-300': '#730E00',
  'palette-red-light-400': '#FDE3E6',
  'palette-blue': '#1173BC',
  'palette-blue-dark-300': '#1B409E',
  'palette-blue-light-300': '#B3D3EB',
  'palette-blue-light-400': '#ECF6FD',
  'palette-green': '#27A86C',
  'palette-green-dark-300': '#036D38',
  'palette-green-light-200': '#89D2B0',
  'palette-green-light-400': '#EEFBF5',
  'palette-purple-light-200': '#C789C5',
  'palette-purple-light-400': '#FBEFFA',
  'palette-purple': '#93278F',
  'palette-purple-dark-300': '#661C66',
  'palette-teal': '#00A38E',
  'palette-teal-dark-300': '#035151',
  'palette-teal-light-400': '#EBFFFD',
  'palette-gold': '#FFAA00',
  'palette-gold-dark-300': '#7A5100',
  'palette-gold-light-300': '#FFE3AB',
  'palette-gold-light-400': '#FFF8EB',
  'palette-orange': '#EC5A13',
  'palette-orange-dark-300': '#712C08',
  'palette-orange-light-400': '#FDF2EC',
  'palette-grey': '#AEB1B5',
  'palette-grey-dark-100': '#95969B',
  'palette-grey-dark-200': '#737478',
  'palette-grey-dark-300': '#4D4C4E',
  'palette-grey-dark-400': '#242528',
  'palette-grey-light-100': '#CACBD1',
  'palette-grey-light-200': '#E3E5E9',
  'palette-grey-light-300': '#F1F1F5',
  'palette-grey-light-400': '#F5F6FA',
  'palette-black': '#000',
  'palette-white': '#FFF',
  'palette-transparent': 'transparent'
};
export const textColor = {
  'color-text-heading': palette['palette-grey-dark-400'],
  'color-text-default': palette['palette-grey-dark-300'],
  'color-text-inverse': palette['palette-white'],
  'color-text-hint': palette['palette-grey'],
  'color-text-placeholder': palette['palette-grey-dark-100'],
  'color-text-disabled': palette['palette-grey-dark-100'],
  'color-text-button-disabled': palette['palette-grey-light-100'],
  'color-text-readonly': palette['palette-grey-dark-300'],
  'color-text-error': palette['palette-red-dark-200'],
  'color-text-success': palette['palette-green']
};
export const backgroundColor = {
  'color-background-page': palette['palette-grey-light-400'],
  'color-background-surface': palette['palette-white'],
  'color-background-input-disabled': palette['palette-grey-light-300'],
  'color-background-input-readonly': palette['palette-grey-light-300'],

  /**
   * @deprecated Please use 'product-color' instead
   */
  'color-background-input-checkbox-checked': palette['palette-grey-dark-200'],

  /**
   * @deprecated Please use 'palette-transparent' instead
   */
  'color-background-transparent': 'transparent'
};
export const borderColor = {
  'color-border-surface': palette['palette-grey-light-200'],
  'color-border-input': palette['palette-grey'],
  'color-border-input-hover': palette['palette-grey-dark-100'],
  'color-border-input-focus': palette['palette-grey-dark-300'],
  'color-border-error': palette['palette-red-dark-200'],
  'color-border-error-hover': palette['palette-red-dark-300'],
  'color-border-error-focus': palette['palette-red-dark-300'],
  'color-border-input-disabled': palette['palette-grey-light-200']
};
export const brandColor = {
  'pushpay-color-blue': '#1E2851',
  'pushpay-color-blue-light-100': '#55618D',
  'pushpay-color-blue-light-200': '#8C9AC8'
};